// src/lib/budgetChecks.js
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Returns true if the user has at least one subcategory with a non-zero amount.
 * Your schema: a flat "budgets" collection filtered by userId, each with an array subcategories[].
 */
export async function userHasAnyBudgetAmounts(uid) {
  if (!uid) return false;

  const q = query(collection(db, "budgets"), where("userId", "==", uid));
  const snap = await getDocs(q);
  if (snap.empty) return false;

  // Walk each document's .subcategories[] and look for any > 0
  for (const docSnap of snap.docs) {
    const data = docSnap.data() || {};
    const subs = Array.isArray(data.subcategories) ? data.subcategories : [];
    const any = subs.some((s) => {
      const raw = (s && (s.amount ?? s.monthlyAmount ?? s.value)) || 0;
      const n = Number(raw);
      return !Number.isNaN(n) && n > 0;
    });
    if (any) return true;
  }
  return false;
}